import React, { FC, useMemo } from 'react'
import { useHideModal } from '@libs/components'
import { Button, Modal, Typography } from 'antd'
import { useLocalization } from '@libs/localization'
import { TaskModalCommonProps } from '../types'
import { Close24 } from '@carbon/icons-react'
import TaskModalTitle from 'modules/common/TaskModalTitle'
import { useAITextEditorLink } from '../hooks'
import { TaskStatus } from '@libs/api'

export interface TaskAITextModalProps extends TaskModalCommonProps {}

const TaskAITextModal: FC<TaskAITextModalProps> = ({ task, onTaskCancel }) => {
	const hideModal = useHideModal()
	const { t } = useLocalization()
	const { data: aiTextEditorLink, isLoading, isFetched } = useAITextEditorLink(task.id)

	const onOpenAIText = () => {
		window.open(aiTextEditorLink, '_blank')
	}

	const descriptionMessage = useMemo(() => {
		if (task.status === TaskStatus.Complete) {
			return t('modals.aiText.alreadyCompleted')
		}
		return aiTextEditorLink ? t('modals.aiText.message') : t('modals.aiText.emptyMessage')
	}, [aiTextEditorLink, t, task.status])

	return (
		<Modal
			visible
			closeIcon={<Close24 />}
			title={<TaskModalTitle title={t('modals.aiText.title')} caseId={task.caseReference} />}
			onCancel={onTaskCancel ? () => onTaskCancel(task) : hideModal}
			footer={
				aiTextEditorLink ? (
					<Button type="primary" onClick={onOpenAIText} disabled={isLoading}>
						{t('common.actions.openAIText')}
					</Button>
				) : null
			}
		>
			{!isLoading && isFetched && <Typography.Paragraph>{descriptionMessage}</Typography.Paragraph>}
		</Modal>
	)
}

export default TaskAITextModal
